export default "__VITE_ASSET__5ME38kKc__"